import { Box, Container, Typography } from "@mui/material";
import BenefitItem from "./BenefitItem";
import ComparisonBox from "./ComparisonBox";
import { benefits, comparison } from "./data/whyData";

export default function WhyProduct() {
  return (
    <Box
      sx={{
        width: "100%",
        py: 4,
      }}
    >
      <Container
        maxWidth={false}
        sx={{
          // maxWidth: "1440px",
          px: {
            xs: 2,
            sm: 4,
            md: "84px",
          },
        }}
      >
        {/* Title */}
        <Typography
          variant="h2"
          sx={{
            fontSize: {
              xs: "2rem",
              sm: "2.5rem",
              md: "3rem",
            },
            fontWeight: 700,
            color: "#2A2177",
            mb: 3,
            // mb: "48px",
            // textAlign: { xs: "center", md: "left" },
          }}
        >
          Why Product Agnostic Matters
        </Typography>

        {/* CONTENT */}
        <Box
          sx={{
            display: "flex",
            flexDirection: {
              xs: "column",
              md: "row",
            },
            alignItems: {
              xs: "center",
              sm: "flex-start",
              md: "flex-start",
            },
            justifyContent: "center",
            gap: 3,
          }}
        >
          {/* LEFT */}
          <Box
            sx={{
              px: {
                xs: "16px",
                md: 0,
              },
              width: {
                xs: "100%",
                sm: "50%",
                md: "50%",
              },
            }}
          >
            {benefits.map((item, i) => (
              <BenefitItem key={i} {...item} />
            ))}
          </Box>

          {/* RIGHT */}
          <Box
            sx={{
              px: {
                xs: "16px",
                md: 0,
              },
              width: {
                xs: "100%",
                sm: "100%",
                md: 624,
              },
              // width: "100%",
              // flex: 1,
              // width: {
              //   xs: "100%",
              //   md: "50%",
              // },
            }}
          >
            <ComparisonBox data={comparison} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
